import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from '@shared/components/Layout';
import { AuthGuard } from '@features/auth/components/AuthGuard';
import { LoginPage } from '@features/auth/pages/LoginPage';
import { DashboardPage } from '@features/dashboard/pages/DashboardPage';
import { ProductsPage } from '@features/products/pages/ProductsPage';
import { ProductDetailPage } from '@features/products/pages/ProductDetailPage';
import { TasksPage } from '@features/tasks/pages/TasksPage';
import { NewTaskPage } from '@features/tasks/pages/NewTaskPage';
import { TaskDetailPage } from '@features/tasks/pages/TaskDetailPage';
import { ApprovalsPage } from '@features/approvals/pages/ApprovalsPage';
import { ActionsPage } from '@features/actions/pages/ActionsPage';
import { OrdersPage } from '@features/orders/pages/OrdersPage';
import { OrderDetailPage } from '@features/orders/pages/OrderDetailPage';
import { SettingsPage } from '@features/settings/pages/SettingsPage';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route element={<AuthGuard />}>
          <Route element={<Layout />}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/:id" element={<ProductDetailPage />} />
            <Route path="/tasks" element={<TasksPage />} />
            <Route path="/tasks/new" element={<NewTaskPage />} />
            <Route path="/tasks/:taskId" element={<TaskDetailPage />} />
            <Route path="/approvals" element={<ApprovalsPage />} />
            <Route path="/actions" element={<ActionsPage />} />
            <Route path="/orders" element={<OrdersPage />} />
            <Route path="/orders/:orderId" element={<OrderDetailPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
